<template>
 <div class="loginClient">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
      <CCard class="p-4 login-card">
        <CCardBody>
          <CForm @submit.prevent="performLogin">
            <center>
              <h1 style="color:#fd131a">Login</h1>
              <p class="text-muted">Session Equipe</p>
            </center>

            <CInput
              required
              placeholder="Login ..."
              v-model="login"
              class="mb-3"
            >
              <template #prepend-content>
                <CIcon name="cil-user" />
              </template>
            </CInput>

            <div class="password-wrapper">
              <CInput
                required
                placeholder="Mot de passe ..."
                :type="show ? 'text' : 'password'"
                v-model="password"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked" />
                </template>
              </CInput>

              <i
                class="fas"
                :class="show ? 'fa-eye' : 'fa-eye-slash'"
                @click="show = !show"
              ></i>

              <div
                class="strength"
                :class="'level_' + strengthLevel"
              ></div>
            </div>

            <CButton
              type="submit"
              color="primary"
              block
              class="mt-4"
            >
              {{ isLoading ? "En cours..." : "Se connecter" }}
            </CButton>

            <div class="text-center mt-3">
              <router-link style="color:#000000" to="/inscription">
                Vous n'avez pas encore un compte ?
                <b style="color:#fd131a"> S'inscrire</b>
              </router-link>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  </div>
</div>

</template>

<script>
import axios from "axios";
import { apiDomain } from "../../config";
export default {
  components: {},
  name: "login",
  data() {
    return {
      tokenVerifEmail: "",
      isLoadingVerifEmail: false,
      errorTokenVerifEmail: null,
      infoVerifEmail: null,
      showLogin: false,

      login: "",
      password: "",
      email: "",
      infoModal: false,
      loggedIn: false,
      //error: "",
      isCreating: false,
      show: false,
      formstate: {},
      validationErrors: "",
      //modifier password
      password: "",
      password_confirmation: "",

      erreurEmail: null,
      token: "",
      errorToken: null,
      newPassword: "",
      errornewPaswword: null,
      passwordAgain: "",
      errorpasswordAgain: null,
      tokenValid: false,
      EmailValid: false,
      infoEmail: null,
      infoToken: null,

      user: null,
      infoToken1: "Verifier avec Succès",

      status_msg: "",
      status: "",
      //error: "",
      errors: [],
      isLoading: false,
    };
  },

  computed: {
    isPasswordMatching() {
      if (
        this.password == "" ||
        this.password_confirmation == "" ||
        this.password != this.password_confirmation
      )
        return true;
      return false;
    },
  },

  mounted() {},

  methods: {
    showNotification(message) {
      this.status_msg = message;
      setTimeout(() => {
        this.status_msg = "";
      }, 120000);
    },

    performLogin() {
      this.isLoading = true;
      this.$store
        .dispatch("performLoginClientAction", {
          login: this.login,
          password: this.password,
        })
        .then((res) => {
          this.isLoading = false;
          this.$noty.success("Connexion réussie.");
          this.$router.push("/vidange");
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.status == 422) {
            this.isLoading = false;
            this.errors = error.response.data.errors;
          }
          if (error.response.status == 401) {
            this.isLoading = false;

            this.$noty.error("OOPS! Login ou password invalid");
          }
          if (error.response.status == 403) {
            this.isLoading = false;

            this.$noty.error("OOPS! Votre Compte n'est pas activer");
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>




.login-card {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

/* Password input wrapper */
.password-wrapper {
  position: relative;
}

/* Eye icon */
.password-wrapper i {
  position: absolute;
  right: 15px;
  top: 0;
  cursor: pointer;
  color: #666;
}

/* Strength bar */
.strength {
  height: 4px;
  margin-top: 5px;
  border-radius: 20px;
  transition: width 0.4s;
}

/* Strength levels */
.level_0 { width: 25%; background: #bb4440; }
.level_1 { width: 25%; background: #bb4440; }
.level_2 { width: 50%; background: #e17d30; }
.level_3 { width: 75%; background: #f0b03f; }
.level_4 { width: 100%; background: #a5df41; }

/* MOBILE */
@media (max-width: 576px) {
  .login-card {
    padding: 20px !important;
  }

  h1 {
    font-size: 1.6rem;
  }
}

/* TABLETTE */
@media (min-width: 577px) and (max-width: 991px) {
  .login-card {
    padding: 25px !important;
  }
}

/* DESKTOP */
@media (min-width: 992px) {
  .login-card {
    padding: 30px !important;
  }
}

</style>
